const config = {
  API_URL: process.env.REACT_APP_API_URL || 'https://api.inklandtattoo.fr',
  ENV: process.env.REACT_APP_ENV || 'development',
  APP_NAME: 'Inkland Administration',
  VERSION: '1.0.0',
};

export default config;
